const majorTag = 'act'
const settings = {
  //项目名称
  title: '注册会计师机考模拟系统',
  //机考辅导类型
  category: '注册会计师',
  //机考辅导ID
  majorID:3,//
  // 综合阶段siteCourseID=16681&courseID=357 不同页面 
  compositeSiteCourseIDs: [16681, 16682, 16563],
  compositeCourseID: 357,
  //辅导名称
  majorTag:majorTag,
  //生产环境二级路径
  publicPath: '/qzSim/'+majorTag+'/',
  //生产环境构建文件目录
  outputDir: 'webApp',
  //静态资源放置目录
  assetsDir: 'static',
  //aes密钥
  aesKey: '823s4125660ijf;*',
  //iv密钥
  ivKey: 'qyu148#4(1p_1^4;',
  //请求接口地址
  baseApi: '/simPaperGw/moniexam',
  //请求重试delay
  retryDelay: 5000
}

module.exports = settings
